import React, {createContext, useMemo, useRef} from 'react';

export const SlideRefContext = createContext<{
    slideRef: React.RefObject<HTMLDivElement>;
    slidesContainerWrapperRef: React.RefObject<HTMLDivElement>;
}>({
    slideRef: {current: null},
    slidesContainerWrapperRef: {current: null},
});

function SlideRefContextProvider({children}: {children: JSX.Element}): JSX.Element {
    const slideRef = useRef(null);
    const slidesContainerWrapperRef = useRef(null);

    const slideRefValue = useMemo(() => ({slideRef, slidesContainerWrapperRef}), [slideRef, slidesContainerWrapperRef]);

    return <SlideRefContext.Provider value={slideRefValue}>{children}</SlideRefContext.Provider>;
}

export default SlideRefContextProvider;
